/**
 * @generated SignedSource<<00115264d567275915a9fffd6d488427>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "firstName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lastName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "legalContractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locationName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "npi"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tin"
  }
],
v1 = {
  "kind": "Variable",
  "name": "firstName",
  "variableName": "firstName"
},
v2 = {
  "kind": "Variable",
  "name": "lastName",
  "variableName": "lastName"
},
v3 = {
  "kind": "Variable",
  "name": "legalContractId",
  "variableName": "legalContractId"
},
v4 = {
  "kind": "Variable",
  "name": "locationName",
  "variableName": "locationName"
},
v5 = {
  "kind": "Variable",
  "name": "npi",
  "variableName": "npi"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContractPractitionersTableRefetch",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "tin",
            "variableName": "tin"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ContractPractitionersTableFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContractPractitionersTableRefetch",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "tIN",
                "variableName": "tin"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "Practitioner",
        "kind": "LinkedField",
        "name": "filteredPractitioners",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerIdentifier",
            "kind": "LinkedField",
            "name": "identifiers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentifierType",
                "kind": "LinkedField",
                "name": "identifierType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerVersion",
            "kind": "LinkedField",
            "name": "applicableVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "812a1958ec82ac3df761fe1bed2c9df5",
    "id": null,
    "metadata": {},
    "name": "ContractPractitionersTableRefetch",
    "operationKind": "query",
    "text": "query ContractPractitionersTableRefetch(\n  $firstName: String = null\n  $lastName: String = null\n  $legalContractId: ID = null\n  $locationName: String = null\n  $npi: String = null\n  $tin: String = null\n) {\n  ...ContractPractitionersTableFragment_1MvSS3\n}\n\nfragment ContractPractitionersTableFragment_1MvSS3 on Query {\n  filteredPractitioners(input: {firstName: $firstName, lastName: $lastName, npi: $npi, tIN: $tin, legalContractId: $legalContractId, locationName: $locationName}) {\n    id\n    identifiers {\n      identifierType {\n        code\n        id\n      }\n      value\n      id\n    }\n    applicableVersion {\n      displayName\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6c021df76268d3354ed199066abdbebb";

export default node;
